import styled from "@mui/styled-engine-sc";

export const PrendreRDVSvg = styled((props) => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M11.6667 0C12.1269 0 12.5 0.3731 12.5 0.833333V1.66667H13.3333C14.2538 1.66667 15 2.41286 15 3.33333V15C15 15.9205 14.2538 16.6667 13.3333 16.6667H1.66667C0.746192 16.6667 0 15.9205 0 15V3.33333C0 2.41286 0.746192 1.66667 1.66667 1.66667H2.5V0.833333C2.5 0.3731 2.8731 0 3.33333 0C3.79357 0 4.16667 0.3731 4.16667 0.833333V1.66667H10.8333V0.833333C10.8333 0.3731 11.2064 0 11.6667 0ZM1.66667 15H13.3333V6.66667H1.66667V15ZM9.8275 8.16083C10.1529 7.83533 10.6804 7.83533 11.0058 8.16083C11.3313 8.48625 11.3313 9.01375 11.0058 9.33917L6.83917 13.5058C6.51375 13.8313 5.98625 13.8313 5.66081 13.5058L3.99414 11.8392C3.6687 11.5138 3.6687 10.9863 3.99414 10.6608C4.31957 10.3353 4.84709 10.3353 5.17252 10.6608L6.25 11.7382L9.8275 8.16083ZM1.66667 5H13.3333V3.33333H1.66667V5Z" fill="black"/>
    </svg>
))`
  ${({ theme }) => `
    display: block;
    margin: 0 auto;
    max-width: 100%;
  `}
`;


